import { parse } from 'papaparse';
import { Buffer } from 'buffer';
import { PriceTable, ValueMapping } from '../AppContext.js';

export const parsePriceTableCsv = (priceTableConfig: PriceTableKonfiguration): PriceTable => {
  window.Buffer = Buffer;
  const results = parse(priceTableConfig.priceCsv, {
    delimiter: ',',
    escapeChar: '"',
    skipEmptyLines: true,
  });
  const records = results.data as string[][];
  let hoehe = priceTableConfig.stepRows;
  return records.reduce((prev: { [key: number]: { [key: number]: number } }, curr: string[]) => {
    let breite = priceTableConfig.stepCols;
    // eslint-disable-next-line no-param-reassign
    prev[hoehe] = curr.reduce((prev2: { [key: number]: number }, curr2: string) => {
      // eslint-disable-next-line no-param-reassign
      prev2[breite] = Number(curr2.replace('.', '_').replace(',', '.').replace('_', ''));
      breite += priceTableConfig.stepCols;
      return prev2;
    }, {});
    hoehe += priceTableConfig.stepRows;
    return prev;
  }, {} as PriceTable);
};

export const parseValueMappingCsv = (valueMappingCsv: string): ValueMapping => {
  window.Buffer = Buffer;
  const results = parse(valueMappingCsv, {
    delimiter: ',',
    escapeChar: '"',
    skipEmptyLines: true,
  });
  const records = results.data as string[][];
  return records.reduce((prev: ValueMapping, curr: string[]) => {
    const kEigenschaftWert = Number(curr[0].replace('.', '_').replace(',', '.').replace('_', ''));
    const value = Number(curr[1].replace('.', '_').replace(',', '.').replace('_', ''));
    // eslint-disable-next-line no-param-reassign
    prev[kEigenschaftWert] = value;
    return prev;
  }, {});
};

export const calculatePrice = (priceTable: PriceTable, breite: number, hoehe: number, steuer: number): number => {
  const hoeheForCalculation = Math.ceil(hoehe / 100) * 100;
  const priceHoehe = priceTable[hoeheForCalculation];
  const breiteForCalculation = Math.ceil(breite / 100) * 100;
  const priceFromTable = priceHoehe?.[breiteForCalculation];
  return Math.round(priceFromTable * (1 + steuer / 100) * 100) / 100;
};
